import { Handle, Position } from '@xyflow/react';

import { Badge } from '@commenda/kakashi';
import { TSysToolCallStepDefinition } from '@commenda/types';

import { WorkflowHandlerID } from '../../workflow/ui';
import { useWorkflow } from '../context/WorkflowContext';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { SOURCE_HANDLE_CLASSNAME, TARGET_HANDLE_CLASSNAME } from './helpers';

export const ToolCallNode = (props: TNodeProps) => {
  const { data } = props;
  const { workflow } = useWorkflow();

  // Safe: nodeTypes maps SYS_TOOL_CALL to this component, so the step at data.id is that type.
  const selectedStep = workflow?.steps.find((step) => step.id === data.id) as
    | TSysToolCallStepDefinition
    | undefined;

  // Showing the tool name on the canvas is what distinguishes this from an agent step at a glance: the step's
  // whole behaviour is which tool it calls, so a node without it reads as unconfigured.
  const toolName = selectedStep?.toolName;

  return (
    <BaseNode {...props} className="min-w-80">
      <div className="px-lg pb-md">
        {toolName ? (
          <Badge variant="gray" size="sm">
            {toolName}
          </Badge>
        ) : (
          <Badge variant="warning" size="sm">
            No tool selected
          </Badge>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_RIGHT}
      />
      <Handle
        type="target"
        position={Position.Left}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_LEFT}
      />
      <Handle
        type="source"
        position={Position.Top}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_TOP}
        style={{ left: '54%' }}
      />
      <Handle
        type="target"
        position={Position.Top}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_TOP}
        style={{ left: '46%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className={SOURCE_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.SOURCE_BOTTOM}
        style={{ left: '54%' }}
      />
      <Handle
        type="target"
        position={Position.Bottom}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_BOTTOM}
        style={{ left: '46%' }}
      />
    </BaseNode>
  );
};
